import { Component, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { SharedService } from "src/app/modules/gasprecio/services/shared.service";

@Component({
  selector: 'app-select-zone-report',
  templateUrl: './select-zone-report.component.html',
  styleUrls: ['./select-zone-report.component.scss']
})
export class SelectZoneReportComponent implements OnDestroy {
  @Input() ngxDisabled: boolean = true;
  public idGroup: any;
  idGroup$: Subscription;
  public items: any[] = [];
  public zone: any = [];
  sharedZone$: Subscription;
  rol;

  constructor(
    private sharedService: SharedService,
    private gasprecioService: GasprecioService,
  ) {
    this.rol = localStorage.getItem('rol');
    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
    this.sharedZone$ = sharedService.sharedZoneReport.subscribe(
      (sharedZone: string) => {
        if (this.zone !== sharedZone) {
          this.zone = sharedZone;
          console.log(this.zone)
        }
      }
    );
  }

  ngOnInit(): void {
    this.getZones();
  }

  ngOnDestroy() {
    this.sharedZone$.unsubscribe();
  }

  getZones() {
    this.gasprecioService.getZones(this.idGroup).subscribe((data: any) => {
      const zones: any = data;
      zones.forEach((element: any) => {
        if (element.zone_id !== '6178671b46818a57510e921b' && element.zone_id !== '6178671b46818a57510e921a') {
          this.items.push({ name: this.gasprecioService.capitalizeFirstLetter(element['name']), value: element['zone_id'] });
        }
      });
      this.ngxDisabled = false;
    });
  }

  changeZone(event: any) {
    this.zone = event;
    this.sharedService.nextZoneReport = this.zone;
  }
}
